
import { AisInstantSearch } from 'vue-instantsearch'
import algoliaInsights from '@/mixins/algoliaInsights'

export default {
  name: 'AddToCartAlgolia',
  components: {
    AisInstantSearch
  },
  mixins: [algoliaInsights],
  props: {
    objectID: {
      type: String,
      required: true
    },
    queryID: {
      type: String,
      required: false,
      default: null
    },
  }
}
